import Component from './component'
import EnhanceRedirectToSignInPage from './enhancers/EnhanceRedirectToSignInPage'

export default EnhanceRedirectToSignInPage(Component)
